import { useQuery } from '@tanstack/react-query';
import { get } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import {
    useMarketsDescriptionsTtl,
} from '~SpectateStore/hooks/clientStateHooks';

export const useMarketsDescriptionsQuery = (sportSlug) => {

    const url = buildSpectateUrl(
        `/marketsdescriptions/getDescriptions/${sportSlug}`
    );
    const ttl = useMarketsDescriptionsTtl();

    const queryResult = useQuery({
        queryKey: ['marketsDescriptions', sportSlug],
        queryFn: () => get(url).then(res => res.json()),
        staleTime: 1000 * ttl,
        retry: false,
    });

    return queryResult;
};
